import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.css']
})
export class UserMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
